export const countries = [
    'GB',
    'Germany',
] as const;

export type TStorageForecastCountries = typeof countries[number];

export function isStorageForecastCountry (value: string): value is TStorageForecastCountries {
    return countries.includes(value as TStorageForecastCountries);
}

export interface CountryInputFields {
    currency: string;
    maxDuration: number;
    showOnsiteGeneration?: boolean;
    showCMContracts?: boolean;
    showCfDContracts?: boolean;
    countryHasMultiplePolicySupportTypes: boolean;
    showLocationalBalancing?: boolean;
    showFrequencyResponse?: boolean;
    allMarketFrName: string;
    allMarketTooltip: string;
    showTwoStageFrequencyResponse?: boolean;
    twoMarketFrName?: string;
    showLongDuration?: boolean;
    showCycleInterDay?: boolean;
    showTnuos?: boolean;
    showDemandZone?: boolean;
    durationNote: string;
    cfdStrikePriceToolTipInfo: string;
    showCompeteInAfrrE?: boolean;
    showCompeteInBalancing? : boolean;
    showFcaRestrictions? : boolean;
    allowDynamicImportCapacity?: boolean;
}

export const countryInfo: Record<TStorageForecastCountries, CountryInputFields> = {
    Germany: {
        currency: '€',
        maxDuration: 6,
        showCycleInterDay: true,
        durationNote: 'German assets have a maximum duration of 5 hours',
        cfdStrikePriceToolTipInfo: 'Please enter the contract strike price in inflation adjusted terms for the year preceeding the scenario you are running. I.e. 2024real prices for a 2025 scenario. This strike price will be used while the asset is still in contract',
        showFrequencyResponse: true,
        allMarketFrName: 'FCR',
        allMarketTooltip: 'Option to compete in FCR or to reserve capacity for other markets.',
        showTwoStageFrequencyResponse: true,
        twoMarketFrName: 'aFRR Capacity',
        showCompeteInAfrrE: true,
        showOnsiteGeneration: true,
        showFcaRestrictions: true,
        showCMContracts: false,
        showCfDContracts: true,
        countryHasMultiplePolicySupportTypes: true,
        allowDynamicImportCapacity: true,
    },
    GB: {
        currency: '£',
        maxDuration: 12,
        showOnsiteGeneration: true,
        showCMContracts: true,
        showCfDContracts: true,
        countryHasMultiplePolicySupportTypes: false,
        showLocationalBalancing: true,
        showFrequencyResponse: true,
        allMarketFrName: 'Frequency Response',
        allMarketTooltip: 'Option to compete in Frequency Response Market or to reserve capacity for other markets.',
        showLongDuration: true,
        showTnuos: true,
        showDemandZone: true,
        showCompeteInBalancing: true,
        durationNote: 'It is generally advised to run assets of 3+ hours as long duration, and lower duration assets as short duration. This can be changed in the Trading Strategies dropdown.',
        cfdStrikePriceToolTipInfo: 'If awarded a CfD contract, the strike price used when still in contract.  Colocation concerning cfd supported RES assumes Cfd compliant BMU status and metering. The entire RES is assumed to be awarded a cfd at the stated price.',
    },
};
